export const ROOMS_START_LOAD = 'ROOMS_START_LOAD'
export const ROOMS_LOADED = 'ROOMS_LOADED'
export const ROOMS_PAYMENT_REQUIRED = 'ROOMS_PAYMENT_REQUIRED'
